var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{attrs:{"tab-position":_vm.tabPosition}},[_c('el-tab-pane',{attrs:{"label":"Tag"}},[_c('TagManage')],1),_c('el-tab-pane',{attrs:{"label":"配置管理"}},[_vm._v("配置管理")]),_c('el-tab-pane',{attrs:{"label":"角色管理"}},[_vm._v("角色管理")]),_c('el-tab-pane',{attrs:{"label":"定时任务补偿"}},[_vm._v("定时任务补偿")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }